var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"el-fade-in-enter-active","leave-active-class":"el-fade-in-leave-active"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-top-btn",on:{"click":_vm.backToTop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }